class GMap {
	constructor(selector = ".acf-map") {
		this.selector = selector
		this.maps = []

		if (!this.isGoogleMapsReady()) {
			return
		}

		document.querySelectorAll(this.selector).forEach(mapElement => {
			this.maps.push(this.createMap(mapElement))
		})
	}

	isGoogleMapsReady() {
		return typeof window.google !== "undefined" && typeof window.google.maps !== "undefined"
	}

	createMap(mapElement) {
		const markers = Array.from(mapElement.querySelectorAll(".marker"))
		const zoom = Number.parseInt(mapElement.dataset.zoom, 10) || 16
		const map = new google.maps.Map(mapElement, {
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			zoom
		})

		map.markers = markers
			.map(markerElement => this.createMarker(markerElement, map))
			.filter(Boolean)

		this.centerMap(map, zoom)

		return map
	}

	createMarker(markerElement, map) {
		const lat = Number.parseFloat(markerElement.dataset.lat)
		const lng = Number.parseFloat(markerElement.dataset.lng)

		if (Number.isNaN(lat) || Number.isNaN(lng)) {
			return null
		}

		const marker = new google.maps.Marker({
			map,
			position: new google.maps.LatLng(lat, lng)
		})

		const content = markerElement.innerHTML.trim()

		if (content) {
			const infoWindow = new google.maps.InfoWindow({ content })

			marker.addListener("click", () => {
				infoWindow.open(map, marker)
			})
		}

		return marker
	}

	centerMap(map, defaultZoom = 16) {
		if (!map.markers.length) {
			return
		}

		const bounds = new google.maps.LatLngBounds()

		map.markers.forEach(marker => {
			bounds.extend(marker.getPosition())
		})

		if (map.markers.length === 1) {
			map.setCenter(bounds.getCenter())
			map.setZoom(defaultZoom)
			return
		}

		map.fitBounds(bounds)
	}
}

export default GMap